import { deleteOtherAdditionItem } from "@/api/other-addition-items";
import { Button } from "@/components/ui/button";
import {
  OtherAdditionItem,
  OtherAdditionItemType,
  OtherAdditionItemTypeLabels,
} from "@/models/other-addition-items.model";
import { ColumnDef } from "@tanstack/react-table";

const ActionCell = ({
  row,
  deleteOtherAdditionItemCallback,
}: {
  row: any;
  deleteOtherAdditionItemCallback: (id: number) => void;
}) => {
  const handleDeleteOtherAdditionItem = async () => {
    try {
      const res = await deleteOtherAdditionItem(row.original.id);

      if (res) {
        deleteOtherAdditionItemCallback(row.original.id);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Button variant="outline" onClick={handleDeleteOtherAdditionItem}>
      Delete
    </Button>
  );
};
export const getOtherAdditionColumns = (
  deleteOtherAdditionItem: (id: number) => void
): ColumnDef<OtherAdditionItem>[] => [
  {
    accessorFn: (row) => row.type,
    cell: ({ row }) => {
      return (
        <span>
          {
            OtherAdditionItemTypeLabels[
              row.original.type as OtherAdditionItemType
            ]
          }
        </span>
      );
    },
    header: "Type",
  },
  {
    accessorFn: (row) => row.amount,
    cell: ({ row }) => {
      return <span>{row.original.amount}</span>;
    },
    header: "Amount ($)",
  },
  {
    header: "Actions",
    cell: ({ row }) => (
      <ActionCell
        deleteOtherAdditionItemCallback={deleteOtherAdditionItem}
        row={row}
      />
    ),
  },
];
